<template>
<v-fade-transition mode="out-in">
    <router-view />
</v-fade-transition>
</template>

<script>
export default {
    name: 'App',
    metaInfo: {
        title: 'NEO Booking',
        titleTemplate: '%s',
        htmlAttrs: {
            lang: 'en'
        },
        meta: [{
                charset: 'utf-8'
            },
            {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1'
            },
        ],
        methods: {
            // Log the user in
            login() {
                this.$auth.loginWithRedirect()
            },
            // Log the user out
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                })
            }
        }
    }
    }

</script>

<!--style>

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

 @media screen and (max-width: 959px)
      padding-top: 48px !important;
      padding-bottom: 48px !important;
</style-->
